export default "__VITE_ASSET__NWCRhiZt__"